export {
  default as Tooltip,
  TooltipProps,
  tooltipClasses,
} from '@mui/material/Tooltip';
